import * as React from 'react';
import { connect } from 'react-redux';
import * as Components from '../../../components/index';
import * as Models from '../../../models/index';
import * as ActionCreators from '../../../actions/action.creators';

interface StateProps {
	username: string;
	questions: Models.Question[];
	isQuestionsLoaded: boolean;
	processing: boolean;
	allowReset: boolean;
}
interface DispatchProps {
	goToNext(): any;
	setUsername(username: string): any;
}
const mapStateToProps = (state: Models.StoreState): StateProps => ({
	username: state.pwdRecovery.username,
	questions: state.pwdRecovery.questions,
	isQuestionsLoaded: state.pwdRecovery.isQuestionsLoaded,
	processing: state.shell.processing,
	allowReset: state.pwdRecovery.allowReset,
});
const mapDispatchToProps = (dispatch: any): DispatchProps => ({
	goToNext: () => dispatch(ActionCreators.PwdRecovery.goToQuestions()),
	setUsername: (username: string) => dispatch(ActionCreators.PwdRecovery.setUserName(username)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	class Component extends React.Component<StateProps & DispatchProps, any> {
		render() {
			var errors = [];
			if (this.props.questions.length === 0 && this.props.isQuestionsLoaded) errors.push('System unable to find recovery options.');
			if (this.props.allowReset === false) errors.push('System unable to recover your password.');
			return (
				<Components.LayoutBlock fill>
					<Components.LayoutBlock fill className='recovery-phase' align='center'>
						<Components.LayoutBlock inline={true} verticalAlign='center' className='inform-section'>
							<Components.Icon icon='user' size='4' />
							<Components.Label className='recovery-label'>Please enter your User Name</Components.Label>
						</Components.LayoutBlock>
						<Components.LayoutBlock>
							<Components.Textbox
								icon={{ icon: 'user' }}
								placeholder='enter username'
								value={this.props.username}
								onChange={this.props.setUsername.bind(this)}
							/>
						</Components.LayoutBlock>
						{errors.length > 0 && <Components.ListBox height='80px' items={errors} listItemStyle='error-message' />}
					</Components.LayoutBlock>
					<Components.LayoutBlock>
						<Components.Button busy={this.props.processing} onClick={this.props.goToNext.bind(this)}>
							Next
						</Components.Button>
						<Components.Button onClick={() => (window.location.hash = '/')}>To Login</Components.Button>
					</Components.LayoutBlock>
				</Components.LayoutBlock>
			);
		}
	}
);
